import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import { storeComposer } from './storeComposer';

const sagaMiddleware = createSagaMiddleware();

const { rootReducer, rootSaga } = storeComposer();

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware({ thunk: false, serializableCheck: false }),
        sagaMiddleware,
    ],
});

if (rootSaga) {
    sagaMiddleware.run(rootSaga);
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
